import React, { useContext } from "react";
import { CgProfile } from "react-icons/cg";
import { HiOutlineArrowSmallLeft } from "react-icons/hi2";
import { Link, Outlet } from "react-router-dom";
import DesktopProfileMenuIcon from "./DesktopProfileMenuIcon";
import { settingsLinks } from "../../PageComponentData/Profile/ProfilePage";
import OverlayBlock from "../../Pages/ProfileLayout/OverlayBlock";
import { FaCircleUser, FaUser } from "react-icons/fa6";
import { AppContext } from "../../appContext";

export default function DesktopProfileMenuPage({ loggedInUser }) {
     const { userDetails, chatCount } = useContext(AppContext);
    let settingsLinkBlock;
    settingsLinkBlock = settingsLinks?.map((data, i) => {
        return (
            <DesktopProfileMenuIcon data={data} index={i} />
        );
    });
    console.log("logged in user..",loggedInUser)
    return (
        <main className="lg:p-6">
            <section className="mx-auto grid grid-cols-1 bg-white rounded-xl min-h-screen  relative overflow-x-hidden p-6 lg:container lg:grid-cols-3 ">
                <div className="lg:p-4 ">
                    <div className="flex items-center gap-2">
                        <div className="size-9 rounded-full active:bg-blue-50 inline-flex justify-center items-center lg:hidden">
                            <Link to={'/'}>
                                <HiOutlineArrowSmallLeft className="text-2xl text-coalBlack active:bg-sky-50" />
                            </Link>
                        </div>
                        <h1 className="headingText text-coalBlack">Profile</h1>
                    </div>
                    <div className="flex flex-col gap-4 justify-center items-center  ms-0 py-6 w-full">

                        {userDetails?.DoctorProfile?.coverPic ? (
                            <div className="size-20 bg-gray-100 rounded-full">
                                <img
                                    src={userDetails?.DoctorProfile?.coverPic && `${process.env.REACT_APP_API_URL}/${userDetails?.DoctorProfile?.coverPic}`}
                                    className="h-full w-full rounded-full object-cover"
                                />
                            </div>
                        ) : (
                            <div className="size-20 bg-gray-200 flex items-center justify-center rounded-full shadow-sm border ">
                                <FaUser size={35} className="text-gray-400" />
                            </div>
                        )}

                        <h2 className="text-coalBlack baseText !font-medium text-center max-w-[70%] capitalize">
                            {userDetails?.DoctorProfile?.DoctorName}
                        </h2>
                    </div>
                    {/* desktop devices links  */}
                    <div className="space-y-3 hidden lg:block">
                        {settingsLinkBlock}
                    </div>
                </div>
                <OverlayBlock>
                    <Outlet />
                </OverlayBlock>
            </section>
        </main>
    )
}